export const CAREERS_CONVEX_URL = process.env.NEXT_PUBLIC_CAREERS_CONVEX_URL || "https://shocking-poodle-102.convex.cloud";

export interface Job {
	_id: string;
	title: string;
	slug: string;
	company?: string;
	department: string;
	location: string;
	type: string;
	description: string;
	requirements: string[];
	responsibilities: string[];
	salary?: string;
	status?: string;
	isActive: boolean;
}

async function convexQuery<T>(functionPath: string, args: Record<string, unknown> = {}): Promise<T> {
	const res = await fetch(`${CAREERS_CONVEX_URL}/api/query`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			path: functionPath,
			args,
			format: "json",
		}),
		next: { revalidate: 60 },
	});

	if (!res.ok) {
		throw new Error(`Convex query failed: ${res.statusText}`);
	}

	const data = await res.json();
	return data.value;
}

export async function listJobs(): Promise<Job[]> {
	return convexQuery<Job[]>("jobs:list");
}

export async function getJobBySlug(slug: string): Promise<Job | null> {
	return convexQuery<Job | null>("jobs:getBySlug", { slug });
}
